<template>
	<div class="config-tabs bg-grey-b">
		<!-- options -->
		<ul id="configure-tabs" class="nav nav-tabs tabs-inline config-navtabs text-center" v-show="activeMenu == 'configure'">
			<li class="single-arrow">
				<a class="prev" href="#leave-warning" data-toggle="modal">
					<i aria-hidden="true">
						<img src="/images/icons/back-ico.svg" alt="" width="30">
					</i>
				</a>
			</li>
			<li :class="getClass('case')">
				<a
					@click="changeActiveTab('case')"
					id="cases-tab-button"
					data-toggle="tab"
					href="#tab-case"
					aria-expanded="true"
				>
					Case
				</a>
			</li>
			<li :class="getClass('cooling')">
				<a
					@click="changeActiveTab('cooling')"
					id="cooling-tab-button"
					data-toggle="tab"
					href="#tab-cooling"
					aria-expanded="false"
				>
					Cooling
				</a>
			</li>
			<li :class="getClass('motherboard')">
				<a
					@click="changeActiveTab('motherboard')"
					id="motherboard-tab-button"
					data-toggle="tab"
					href="#tab-motherboard"
					aria-expanded="false"
				>
					Motherboard
				</a>
			</li>
			<li :class="getClass('gpu')">
				<a
					@click="changeActiveTab('gpu')"
					id="gpu-tab-button"
					data-toggle="tab"
					href="#tab-gpu"
					aria-expanded="false"
				>
					GPU (GRAPHICS)
				</a>
			</li>
			<li :class="getClass('cpu')">
				<a
					@click="changeActiveTab('cpu')"
					data-toggle="tab"
					href="#tab-cpu"
					aria-expanded="false"
				>
					CPU
				</a>
			</li>
			<li :class="getClass('psu')">
				<a
					@click="changeActiveTab('psu')"
					id="psu-tab-button"
					data-toggle="tab"
					href="#tab-psu"
					aria-expanded="false"
				>
					Power Supplies
				</a>
			</li>
			<li :class="getClass('ram')">
				<a
					@click="changeActiveTab('ram')"
					id="ram-tab-button"
					data-toggle="tab"
					href="#tab-ram"
					aria-expanded="false"
				>
					RAM
				</a>
			</li>
			<li :class="getClass('storage')">
				<a
					@click="changeActiveTab('storage')"
					id="storage-tab-button"
					data-toggle="tab"
					href="#tab-ssd"
					aria-expanded="false"
				>
					Storage: SSD/HDD
				</a>
			</li>
			<li id="colors-menu-button" @click="activateColorsTabBar()">
				<a class="btn btn-green next">MORE
					<i aria-hidden="true">
						<img src="/images/icons/next.svg" alt="" width="30">
					</i>
				</a>
			</li>
		</ul>
		<!-- /.options -->
		<!-- pc-customize-tabs -->
		<!-- options -->
		<ul id="rgbs-tabs" class="nav nav-tabs tabs-inline custom-navtabs text-center" v-show="activeMenu == 'rgbs'">
			<li id="configure-menu-button" @click="activateConfigureTabBar()" class="pointer">
				<a class="prev">
					<i aria-hidden="true">
						<img src="/images/icons/back-ico.svg" alt="" width="30">
					</i> CONFIGURE</a>
			</li>
			<li :class="getClass('rgbs')">
				<a
					@click="changeActiveTab('rgbs')"
					id="rgbs-tab-button"
					data-toggle="tab"
					href="#tab-rgbs"
					aria-expanded="false"
				>
					RGB
				</a>
			</li>
			<li :class="getClass('extras')">
				<a
					@click="changeActiveTab('extras')"
					id="extras-tab-button"
					data-toggle="tab"
					href="#tab-extra"
					aria-expanded="false"
				>
					Accessories
				</a>
			</li>
			<li :class="getClass('peripherals')">
				<a
					@click="changeActiveTab('peripherals')"
					id="peripherals-tab-button"
					data-toggle="tab"
					href="#tab-peripherals"
					aria-expanded="false"
				>
					Peripherals
				</a>
			</li>
			<li :class="getClass('monitor')">
				<a
					@click="changeActiveTab('monitor')"
					id="monitor-tab-button"
					data-toggle="tab"
					href="#tab-monitor"
					aria-expanded="false"
				>
					Monitors
				</a>
			</li>
			<li :class="getClass('color')">
				<a
					@click="changeActiveTab('color')"
					id="color-tab"
					data-toggle="tab"
					href="#tab-color"
					aria-expanded="true"
				>
					Color
				</a>
			</li>
			<li :class="getClass('software')">
				<a
					@click="changeActiveTab('software')"
					data-toggle="tab"
					href="#tab-software"
					aria-expanded="false"
				>
					Software
				</a>
			</li>
			<li :class="getClass('services')">
				<a
					@click="changeActiveTab('services')"
					data-toggle="tab"
					href="#tab-services"
					aria-expanded="false"
				>
					Services
				</a>
			</li>
			<li @click="gotoStep5('bottom')">
				<a class="btn btn-purple next">
					CHECKOUT
					<span class="checkout-icon"/>
				</a>
			</li>
		</ul>
		<!-- /.options -->
		<!-- /.pc-customize-tabs -->
	</div>
</template>

<script>
import { heapAnalytics } from "@u/mixins";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "TabsMenu",
	mixins: [heapAnalytics],
	data() {
		return {
			colorsTabBarActive: false,
			configureTabBarActive: true
		};
	},
	computed: {
		...mapGetters(["activeTab", "activeMenu"])
	},
	methods: {
		...mapActions(["changeActiveMenu", "changeActiveTab"]),
		activateConfigureTabBar() {
			this.changeActiveMenu("configure");
			$("#rgbs-tabs li").removeClass("active");
			$("#cases-tab-button").click();
			this.changeActiveTab("case");
		},
		activateColorsTabBar() {
			this.changeActiveMenu("rgbs");
			$("#configure-tabs li").removeClass("active");
			$("#rgbs-tab-button").click();
			this.changeActiveTab("rgbs");
		},
		getClass(tab) {
			if (tab == this.activeTab) {
				return "active";
			}
			return "";
		},
		gotoStep5(pageLocation) {
			this.trackAll("Client: Click Checkout 2", { page_location: pageLocation });

			this.$router.push({
				name: "step5",
				query: {
					price: this.$route.query.price,
					draft: this.$route.query.draft
				}
			});
		},
		changeTab(tabName) {
			this.changeActiveTab(tabName);
		}
	}
};
</script>
